import $ from './el.JsModules.js';

elabs.VideoService = class {
  'use strict';

  constructor() {
    this.videoContainers = $('.el-video-container');
    if (this.videoContainers.length === 0) {
      return; // There are no videos on the page
    }
    this.initialiseVideos();

    elabs.documentElement.on('WINDOW_RESIZED_EVENT', () => {
      this.initialiseVideos();
    });
  }

  initialiseVideos = () => {
    this.videoContainers.each((index, element) => {
      const videoContainer = $(element);
      const video = videoContainer.find('.el-video');

      // Check if there is a video for desktop vs mobile
      const videoSrcBreakPoint = parseInt(video.data('src-breakpoint'), 10);
      if (videoSrcBreakPoint > 0) {
        // set the correct src for mobile vs desktop
        const currentSrc = video.attr('data-current-src');
        if (elabs.windowElement.width() >= videoSrcBreakPoint) {
          if (currentSrc !== 'desktop') {
            video.attr('src', video.data('src-desktop'));
            video.attr('data-current-src', 'desktop');
          }
        } else {
          if (currentSrc !== 'mobile') {
            video.attr('src', video.data('src-mobile'));
            video.attr('data-current-src', 'mobile');
          }
        }
      }

      // Make sure the video fills its container
      const videoHeight = video.height();
      const videoContainerHeight = videoContainer.height();

      if (videoHeight < videoContainerHeight) {
        video.css('height', '100%');
        video.css('width', 'auto');
      } else {
        video.css('height', 'auto');
        video.css('width', '100%');
      }
    });
  };
};

elabs.onJavascriptReady(function () {
  elabs.VideoService = new elabs.VideoService();
});
